import { FunctionComponent } from 'react'

import { orderBy } from 'lodash'
import styled from 'styled-components'

import { baseColors, Button, Text } from '@fairhq/common'

import { SessionCamelCase } from 'store/company/types'
import { useAppSelector } from 'store/hooks'
import { State } from 'store/state'
import { TableCell, TableRow } from 'ui-kit/Table'

import { AccountAndCompany } from './Admin'

interface AdminListItemProps {
  account: AccountAndCompany
  onClick: (a: AccountAndCompany) => void
}

const StyledButton = styled(Button)`
  padding: 6px 12px;
`
export const AdminListItem: FunctionComponent<AdminListItemProps> = ({
  account,
  onClick,
}) => {
  const { viewingCompanyId } = useAppSelector((state: State) => ({
    viewingCompanyId: state.apiHeadersReducer.companyId,
  }))

  const ViewButton = (
    <StyledButton variant="secondary" onClick={() => onClick(account)}>
      <Text element="p" type="body" size="2xs" fontWeight={500}>
        view
      </Text>
    </StyledButton>
  )

  const latestSession: SessionCamelCase = orderBy(
    account.company.sessions,
    ['startDate'],
    ['desc']
  )[0]

  const rowCells = [
    `${account.company.name} (${latestSession.auditType})`,
    account.company.id,
    account.id,
    ViewButton,
  ]

  return (
    <TableRow
      sx={{
        color:
          viewingCompanyId === account.company.id
            ? baseColors.contentInverseContent
            : 'inherit',
        ':hover': {
          bg: baseColors.statesHoverBackground,
          color: baseColors.contentInverseContent,
        },
        fontWeight: viewingCompanyId === account.company.id ? 'bold' : 'none',
        backgroundColor:
          viewingCompanyId === account.company.id
            ? baseColors.backgroundActive
            : 'white',
      }}
    >
      {rowCells.map((children, index) => (
        <TableCell
          key={index}
          sx={{
            paddingTop: '2px',
            paddingBottom: '2px',
            height: '50px',
          }}
        >
          {children}
        </TableCell>
      ))}
    </TableRow>
  )
}
